export const NEW_NOTE_SHARE_SETTINGS_SCOPE_ID = 'new-note-notes-id';

export function makeExistingNoteShareSettingsScopeId(noteId: string): string {
    return `notes-${noteId}`;
}
